<div class="qr-mobile-detected-container">
    <app-mobile-header [title]="'qr.account.detected.title.2'" [manualBackEvent]="true"
        (onManualBackEvent)="backToPreviousPage()"></app-mobile-header>

    <div class="qrMobileDetected-content">
        <img src="assets/generalImage/user.svg" loading="lazy" alt="mascot" />

        <h1 class="desc" *ngIf="isAccountDetected">{{'desc.found.account' | translate}}</h1>

        <h1 class="desc" *ngIf="isAreYouInterested">{{'qr.phone.submit.title.4' | translate}}</h1>

        <app-button [buttonName]="'button.login' | translate" (click)="onClickLogin()"
            *ngIf="isAccountDetected"></app-button>

        <app-button [buttonName]="'button.register' | translate" (click)="onClickRegister()"
            *ngIf="isAreYouInterested"></app-button>

        <app-button [buttonName]="'button.continue.as.guest' | translate" [borderButton]="true"
            (click)="onClickContinueAsGuest()" *ngIf="showContinueAsGuest"></app-button>

    </div>
</div>